module.exports = __webpack_public_path__ + "img/nopic-female.4daadd88.jpg";